module.exports = __webpack_public_path__ + "img/group.ec570741.png";